module.exports = __webpack_public_path__ + "media/images/Expose-blue-938d208fe97e6a613ddb70b161afc638.svg";